var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"white--text",attrs:{"x-small":"","color":"purple","rounded":""},on:{"click":_vm.onAddFriend}},[_c('v-icon',{attrs:{"left":""}},[_vm._v(" mdi-account-multiple-plus ")]),_vm._v(" Add new ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }